import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFlowStore } from '../store';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const { auth } = useFlowStore();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Process auth callback

        // Try to parse the user data from the response
        const responseText = document.body.innerText;
        if (responseText) {
          try {
            const userData = JSON.parse(responseText);
            // Process user data

            // Set authentication state
            if (userData && userData.id) {
              // Store the user data in localStorage for persistence
              localStorage.setItem('auth_user', JSON.stringify(userData));

              // Update the auth state
              await auth();

              // Redirect to the topics page
              // Redirect to topics page after successful authentication
              navigate('/topics');
              return;
            }
          } catch (parseError) {
            // Handle parse error
          }
        }

        // If we couldn't parse the user data, try to authenticate anyway
        await auth();

        // Redirect to the topics page
        navigate('/topics');
      } catch (error) {
        // Handle auth callback error
        // Redirect to the login page on error
        navigate('/');
      }
    };

    handleCallback();
  }, [auth, navigate]);

  return (
    <div style={{ padding: '24px', textAlign: 'center' }}>
      <h2>Authenticating...</h2>
      <p>Please wait while we complete the authentication process.</p>
    </div>
  );
};

export default AuthCallback;